import { Component, EventEmitter,ViewChild, Output,Input } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-om-perfect-scrollbar';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { VisualsService } from '@core/Abstract/visuals.service';
import { ConfigService } from '@core/Abstract/config.service';
import { MessageService } from '@core/Abstract/newCompany.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {FormBuilder, UntypedFormGroup, Validators, UntypedFormControl} from "@angular/forms";
import { OnboardService } from "app/Menus/Onboard/onboard.service";
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../Core/Auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from './userProfile.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  providers: [OnboardService,UserProfileService]
})
export class NavigationComponent {
  @Output() toggleSidebar = new EventEmitter<void>();
  options;
  @Output() themeChange = new EventEmitter<void>();
  @ViewChild('modal',{static: false}) public modal: ModalDirective;
  public showModal(): void { this.modal.show(); }
  public hideModal(): void { this.modal.hide(); this.resetTheForm()}
  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;
  public isLoading : boolean = false;
  public genericVisuals: any = {};
  private pwdForm: UntypedFormGroup;
  public langs = [];
  public user = {};
  public userName: string;
  private model = {cmpNm:''};
  submitting: boolean = false;
  message: any[] = [];
  subscription: Subscription;
  currentLang: string;
  navbarBrandClass: string = 'navbar-brand';

  constructor(private securityService: SecurityService,
    public translate:TranslateService,
    private eventsEmitterService: EventsEmitterService,
    private messageService: MessageService,
    private userProfileService:UserProfileService,
    public authService:AuthService,
    private onboardService:OnboardService,
    private logger: LogService,
    private visualsService: VisualsService,
    protected configService: ConfigService) {
      this.subscription = this.messageService.getMessage().subscribe(message => {
        if (message) {
          this.message.push(message);
        } else {
          this.message = [];
        }
      });
      this.pwdForm = new UntypedFormGroup({
        'cmpNm': new UntypedFormControl(this.model.cmpNm, [Validators.required]),
        });
    this.langs = this.configService.getLangs();
    this.translate.use(this.currentLang);
    this.eventsEmitterService.languageChange.subscribe(
      langId => {
        this.getGenericVisuals();
        if(langId == '1'){
          this.navbarBrandClass='navbar-brand-lang1';
        }else {
          this.navbarBrandClass='navbar-brand-lang2';
        }        
      }
    );
  }

  ngOnInit(){
    this.getGenericVisuals();
    this.getUser();
  
  }
  resetTheForm() {
    this.pwdForm.reset();
  }
  sendMessage(): void {
    // send message to subscribers via observable subject
    this.messageService.sendMessage('Message from Home Component to App Component!');
}
  public logout() {
    this.authService.logout();
  }
  public theme(){
    this.themeChange.emit();
  }

  private getUser(): void {
    this.userName = localStorage.getItem('userName')
    this.user = localStorage.getItem('home_info') == null ? {} : this.visualsService.getFromStorageAsJSON('home_info', false);
    this.userProfileService.get({}).subscribe(
      data => {
          this.options = JSON.parse(data['options']);
          localStorage.setItem('langId', this.options.language);
          this.currentLang =  this.getCurrentLang(this.options.language);
          this.translate.use(this.currentLang);
         this.eventsEmitterService.languageChange.emit(this.options.language);          
      },
      error => {
      }
  );
  }

  private getGenericVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
  }

  public disabled: boolean = false;

  public changeLang(langId) {
    localStorage.setItem('langId', langId);
    this.currentLang =  this.getCurrentLang(langId);
    this.translate.use(this.currentLang);
   this.saveSettings(langId);
   this.eventsEmitterService.languageChange.emit(langId);
  }
  getCurrentLang(id):string{
    let lang;
    let langId = id;

    this.langs.forEach(element => {
        if(element['id'] == langId){
            lang = element['text'];
        }
    }); 

    return lang;
  }
  saveSettings(lang){
    this.userProfileService.save(lang).subscribe(
      data => {
      },
      error => {
      }
  )
  }
  doRegister(model){
    this.submitting = true
    if(!this.pwdForm.valid){
      return
    }
    this.isLoading = true
    this.onboardService.saveNewCompany(this.pwdForm.getRawValue()).subscribe((res)=>{
      this.isLoading = false
      let resp = res.data
      this.hideModal()
      LogService.emitAlert({
        type: "success",
        body: resp.data
      });
      this.securityService.router.navigate(['/menu/home']);
      
    },
    error => {
      this.isLoading = false
      LogService.emitAlert({
        type: "danger",
        body: "Something went wrong!"
      });
    })
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
}
}
